import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
  Box,
  Button,
  Checkbox,
  Typography,
  FormControlLabel,
  Avatar,
} from "@mui/material";
import {Grid} from "@mui/system";
import style from "../../assets/css/client-select.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState, setAuthData} from "../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {AGENT_CLIENTS} from "../../constants/apiConstant";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {removeCookies} from "../../constants/helper";
import debounce from "lodash/debounce";
import GlobalSearchField from "../global-fields/GlobalSearchField";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Breadcrumbs,
} from "@mui/material";
import NoDataComponent from "../no-data";

const clients = Array.from({length: 11});

const ClientSelect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user} = useSelector(selectAuthState);
  const {dynamicHeaderHeight} = useSelector(selectUiState);
  const leftGridRef = useRef(null);
  const [clientList, setClientList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    loadOptions("");
  }, []);

  const clientSearch = async (searchTerm) => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
      search: searchTerm,
    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        return res?.user_list ?? [];
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
        return [];
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      console.error("Error:", error);
      dispatch(setUiData({showLoader: false}));
      navigate("/");
      return [];
    }
  };

  const loadOptions = async (inputValue) => {
    const normalizedInput = inputValue.toLowerCase();
    const clients = await clientSearch(normalizedInput);
    setClientList(clients);
    return clients.map((client) => ({
      ...client,
      label: (
        <>
          {client.first_name} {client.last_name} <br />
          <small>{client?.email}</small>
        </>
      ),
      value: client.user_id,
    }));
  };

  const debouncedLoadOptions = debounce(loadOptions, 500);

  const handleSelect = (clientSelected) => {
    dispatch(
      setDataStore({
        proposalStep: 1,
        proposal_id: null,
      })
    );
    dispatch(setAuthData({selectedClient: clientSelected}));
    navigate("/new-proposal");
  };

  const columns = [
    {id: "id", label: "#", minWidth: 25},
    {id: "full_name", label: "Client Name", minWidth: 160},
    {id: "mobile_no", label: "Contact", minWidth: 110},
    {id: "email", label: "Email", minWidth: 110},
    {id: "company", label: "Company", minWidth: 160},
    {id: "action", label: "Action", minWidth: 100},
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // console.log("clientList", clientList)
  return (
    <>
      <section className={style.selectClientSection}>
        <Grid
          container
          spacing={1}
          className="customeContainer"
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid size={{xs: 12, md: 12, lg: 6, xl: 5}}>
            <div className={style.selectClientMain}>
              <h2> Search Client</h2>

              <Paper
                className={style.clientSearchMain}
                component="form"
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: 400,
                }}
              >
                <InputBase
                  sx={{ml: 1, flex: 1}}
                  placeholder="Search Client"
                  inputProps={{"aria-label": "client search box"}}
                  onChange={(e) => debouncedLoadOptions(e.target.value)}
                />
                <Divider sx={{height: 28, m: 0.5}} orientation="vertical" />
                <IconButton type="button" sx={{p: "10px"}} aria-label="search">
                  <SearchIcon />
                </IconButton>
              </Paper>

              {/* <GlobalSearchField loadOptions={loadOptions} onSelect={handleSelect} placeH={"Search Client..."} /> */}
              {/* <Button
                                variant="contained"
                                sx={{ mr: 1 }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleConitnue}
                                disabled={selectedClientData === null}
                            >
                                Continue
                            </Button> */}
            </div>
          </Grid>
        </Grid>
      </section>

      <section className={style.clientListSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          sx={{
            alignItems: "center",
            // justifyContent: 'center'
          }}
        >
          <Grid size={{xs: 12}}>
            <Typography
              variant="h6"
              gutterBottom
              sx={{mb: 0.2, fontWeight: 400, mb: 2}}
            >
              Results
            </Typography>
            {clientList?.length ? (
              <Paper className={style.propTableMain}>
                <TableContainer>
                  <Table>
                    <TableHead sx={{background: "grey", color: "white"}}>
                      <TableRow>
                        {columns.map((column) => (
                          <TableCell
                            style={{minWidth: column.minWidth}}
                            key={column.id}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {clientList.map((row, id) => (
                        <TableRow key={row.user_id}>
                          <TableCell>{id + 1}</TableCell>
                          <TableCell>{row.full_name}</TableCell>
                          {/* <TableCell>{row.last_name}</TableCell> */}
                          {/* <TableCell>{row.policyNumber}</TableCell> */}
                          <TableCell>{row.mobile_no}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{row.company}</TableCell>
                          {/* <TableCell>{row.dateReported}</TableCell> */}
                          {/* <TableCell>{row.DOL}</TableCell>
                          <TableCell>{row.estimatedLoss}</TableCell>
                          <TableCell>{row.TOL}</TableCell> */}
                          <TableCell>
                            <Button
                              //disabled
                              variant="contained"
                              style={{
                                background: "#004f71",
                                padding: "4px 12px",
                                textTransform: "capitalize",
                              }}
                              // className={style.IssuedPolicyBtnSucces}
                              onClick={() => {
                                handleSelect(row);
                              }}
                            >
                              Select
                            </Button>
                            {/* <Button disabled style={{ color: "#ff8607" }} className={style.IssuedPolicyBtnDanger}>  {row.action} </Button>
                            <Button disabled style={{ color: "#ff3d32" }} className={style.IssuedPolicyBtnExpired}>  {row.action} </Button> */}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={clientList.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            ) : (
              <NoDataComponent />
            )}
          </Grid>

          {/* {clientList?.length > 0 && clientList.map((item, index) => (
                        <Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 3 }}>
                            <Box
                                sx={{
                                    borderRadius: '8px',
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    position: 'relative',
                                    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                                }}
                            >
                                <IconButton
                                    onClick={() => { handleSelect(item) }}
                                    sx={{ position: 'absolute', top: 8, right: 8 }}
                                >
                                    <ArrowForwardIosIcon />
                                </IconButton>

                                <Avatar
                                    variant="rounded"
                                    alt={"profile-img-client" + item.id}
                                    src={item?.image ?? "https://avatar.iran.liara.run/public/1"}
                                    sx={{ width: 64, height: 64, mr: 2 }}
                                />

                                <Box>
                                    <Typography variant="h6" gutterBottom sx={{ mb: 0.5 }}>
                                        {`${item?.first_name} ${item?.last_name}`}
                                    </Typography>

                                    <Box display="flex" alignItems="center" mb={1}>
                                        <EmailIcon fontSize="small" sx={{ mr: 1, color: '#004f71' }} />
                                        <Typography variant="body2">{item.email}</Typography>
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                        <PhoneIcon fontSize="small" sx={{ mr: 1, color: '#004f71' }} />
                                        <Typography variant="body2">{item.mobile_no}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    ))} */}
        </Grid>
      </section>
    </>
  );
};

export default ClientSelect;
